// ФТУЕ.0: хук работы с локалью.
//
// Возвращает текущий язык + setter, который меняет язык локально и
// одновременно делает PATCH /api/profile/me { locale } на сервере.
//
// Если сервер недоступен (offline) — язык всё равно сменится локально,
// а серверная синхронизация попробуется снова при следующем логине.

import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { setLocaleLocal, type Locale } from './index';
import { updateProfile } from '../api/client';

export function useLocale() {
  const { i18n } = useTranslation();
  const current = (i18n.language === 'en' ? 'en' : 'ru') as Locale;

  const setLocale = useCallback(async (next: Locale) => {
    if (next === current) return;
    // 1) Локально — мгновенно (UI перерисовывается).
    setLocaleLocal(next);
    // 2) На сервер — фоном. Ошибку прячем, чтобы не блокировать UX.
    try { await updateProfile({ locale: next }); } catch { /* offline / 401 — ок */ }
  }, [current]);

  return { locale: current, setLocale };
}
